import React, { Component } from "react";
import {
  StyleSheet,
  TouchableOpacity,
  Text,
  Keyboard,
  Vibration,
} from "react-native";

function ButtonLayout(props) {
  return (
    <TouchableOpacity
      style={{ ...styles.container, ...props.style }}
      onPress={() => {
        props.onPress();
        Keyboard.dismiss(), Vibration.vibrate(200);
      }}>
      <Text style={styles.label}>{props.text}</Text>
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  label: {
    fontFamily: "Montserrat-Regular",
    color: "#3E4672",
    fontSize: 17,
    textAlign: "center",
    lineHeight: 38,
    justifyContent: "center",
    width: 250,
    height: 38,
    alignSelf: "center",
    backgroundColor: "#fff",
    borderRadius: 15,
    marginBottom: 20,
    marginTop: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
  container: {
    flexDirection: "column",
    justifyContent: "center",
    width: 250,
    height: 38,
    alignSelf: "center",
    backgroundColor: "#fff",
    borderRadius: 15,
    marginBottom: 20,
    marginTop: 20,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
});

export default ButtonLayout;
